<fgb-page-header [pageTitle]="'wallet.redeemed.title'" [showBalance]="false"></fgb-page-header>
<div class="container">
  <div class="d-flex flex-column align-items-start py-lg-4 pb-2">
    <!-- Back Button -->
    <div class="d-none d-lg-block mb-3">
      <div class="back-btn text-white cursor-pointer" (click)="back()">
        <span class="material-icons"> arrow_back_ios </span>
      </div>
    </div>
    <!-- Title -->
    <h5 class="m-0 text-black fw-bold wallet-redeemed-title text-uppercase">{{ 'wallet.redeemed.history' | translate }}</h5>
  </div>
  <ng-container
    *ngIf="
      {
        walletItemsClaimed: walletItemsClaimed$ | async
      } as walletItems;
      else noWalletItems
    "
  >
    <ng-container *ngIf="walletItems.walletItemsClaimed && walletItems.walletItemsClaimed.length; else noWalletItems">
      <fgbcl-rewards-wallet-redeemed-list [redeemedItems]="walletItems.walletItemsClaimed"></fgbcl-rewards-wallet-redeemed-list>
    </ng-container>
  </ng-container>
</div>

<ng-template #noWalletItems>
  <div class="container">
    <div class="border rounded">
      <div class="fw-bold font-size-12 text-center text-grey py-3">
        {{ 'claimed.rewards.placeholder.description' | translate }}
      </div>
    </div>
  </div>
</ng-template>
